// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app-worker-page {\n  padding: 10px 34px;\n}\n.app-worker-page-tabs {\n  margin-top: 20px;\n  margin-bottom: 27px;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
